import { useState } from 'react'
import { useInvalidate } from '@refinedev/core'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'

import { ordersPatchCancellationRequestApprovalMutation } from '@repo/sdk'

import { useInvalidateFulfillmentOrders } from '../orders/useInvalidateFulfillmentOrders'

export function useApproveCancellation() {
  const invalidate = useInvalidate()
  const queryClient = useQueryClient()
  const invalidateFulfillmentOrders = useInvalidateFulfillmentOrders()
  const { message } = App.useApp()
  const { t } = useTranslation()
  const [isInvalidating, setIsInvalidating] = useState(false)

  const { mutate, isPending } = useMutation({
    ...ordersPatchCancellationRequestApprovalMutation(),
    onSuccess: async (_data, variables) => {
      message.success(t('common.modals.approveCancellationSuccess'))
      setIsInvalidating(true)
      await Promise.all([
        // `detail` only matches when the id is supplied — without it the detail stays stale.
        invalidate({
          resource: 'cancellation-list',
          invalidates: ['list', 'detail'],
          id: variables.path?.cancellationId,
        }),
        queryClient.invalidateQueries({ queryKey: ['cancellationTabCounts'] }),
        // The order/FO status in 판매내역 changes with the approval.
        invalidateFulfillmentOrders(),
      ])
      setIsInvalidating(false)
    },
    onError: () => {
      message.error(t('common.modals.approveCancellationFailed'))
    },
  })

  const approveCancellation = (cancellationId: string) => {
    mutate({ path: { cancellationId } })
  }

  return { approveCancellation, isApproving: isPending || isInvalidating }
}
